import {useProfiles} from '@/api/User/useProfiles';
import {useColors} from '@/hooks/MLSChallenge/usePatterns';
import {getAge} from '@/user/user-utils';
import {memo, useMemo} from 'react';
import {useNavigate} from 'react-router-dom';
import {PlayerCardDisplay, PlayerCardDisplayData} from './PlayerCardDisplay';

interface PlayerCardProps {
  containerClassNames?: string;
}

export const PlayerCard = memo(({containerClassNames = ''}: PlayerCardProps) => {
  const colors = useColors();
  const navigate = useNavigate();
  const {
    currentProfile: {jerseyInfo, playerCardInfo, firstName = '', lastName = '', dob, lifeTimeReps = 0, score},
  } = useProfiles();

  const averageScore = score?.averageScore ?? 0;

  const jerseyColorIndex = useMemo(() => {
    const colorIndex = colors.findIndex((color) => color.lightColor === jerseyInfo?.jerseyLightColor);
    if (colorIndex === -1) {
      return 0;
    }
    return colorIndex;
  }, [jerseyInfo, colors]);

  const playerCardColorIndex = useMemo(() => {
    const colorIndex = colors.findIndex((color) => color.lightColor === playerCardInfo?.playerCardLightColor);
    if (colorIndex === -1) {
      return 0;
    }
    return colorIndex;
  }, [playerCardInfo, colors]);

  const patternIndex = playerCardInfo?.patternIndex || 0;
  const age = getAge(dob) || 0;
  const imgSrc = playerCardInfo?.imageSrc;
  const textColor = playerCardInfo?.playerCardTextColor || colors[playerCardColorIndex]?.textColor;

  const handleNavigate = (event: React.MouseEvent, path: string) => {
    event.stopPropagation();
    navigate(path);
  };

  const playerCardData: PlayerCardDisplayData = {
    // Player info
    firstName,
    lastName,
    age,
    lifeTimeReps,
    imgSrc,

    // Jersey info
    jerseyName: jerseyInfo?.jerseyName || '',
    jerseyNumber: jerseyInfo?.jerseyNumber?.toString() || '',
    jerseyColorIndex,

    // Player card styling
    playerCardColorIndex,
    patternIndex,
    textColor: textColor || '#000000',

    // Score info
    averageScore,
    showScore: true, // Show the TOCA Score on the player card
  };

  return (
    <PlayerCardDisplay
      data={playerCardData}
      containerClassNames={containerClassNames}
      onCardClick={() => navigate('/avatar-creator')}
      onJerseyClick={(e) => handleNavigate(e, '/customize-jersey')}
      onScoreClick={(e) => {
        e.stopPropagation();
        navigate('/my-score');
      }}
      isPlayerCard={true}
    />
  );
});

PlayerCard.displayName = 'PlayerCard';
